module.exports = __webpack_public_path__ + "static/media/game(16).eeb7a3c2.PNG";